import { useQuery } from '@tanstack/react-query';
import { ModelType } from 'types';
import { fetchWithType } from 'utils/api';
import { getAdminUrl, getApiToken } from 'utils/helpers';

function useModels() {
  const { data, ...rest } = useQuery({
    queryKey: ['models'],
    queryFn: async () => {
      return await fetchWithType<ModelType[]>(getAdminUrl() + '/api/models', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getApiToken()}`,
        },
      });
    },
  });
  return { models: data?.data ?? [], ...rest };
}

export default useModels;
